import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectAnnouncementsQueryItems } from '../../../../../redux/announcements/selector';
import { announcements } from '../../../../../redux/announcements/action';
import AnnouncementComponent from '../components/announcements.component';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import * as R from "ramda"
import { selectListItems } from '../../../../../redux/library/selector';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
let currentChange: any = {}
const ManagementAnnouncement = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const websitesItems = useSelector(selectWebsitesListItems)
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  const announcementsQuery = useSelector(selectAnnouncementsQueryItems)
  const libraryData = useSelector(selectListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<any>({
    IsLimitedToRoute: false,
    MappedChannels: {
      MappedChannelIds: []
    },
    LimitedToOrganizationMappings: {
      LimitedToOrganizationUnitIds: []
    },
    MediaMappings: {
      MediaFiles: []
    },
  })
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const [
    announcementImageIndex,
    setAnnouncementImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
  const handleInnerFormItemChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedAnnouncement({ ...selectedAnnouncement, [fields[0]]: value });
  }
  const fetchAnnouncementQueryById = () => {
    dispatch(announcements.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/query`,
      entity: 'announcements',
      jsonData: {
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedAnnouncement({ ...selectedAnnouncement, [field]: event })
  }

  useEffect(
    () => {

      dispatch(organizationUnits.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {} }))
        .then(async () => {
          await dispatch(websites.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
            }
          }))
          await dispatch(accountWebPages.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
            }
          }))
          if (parmas?.id > 0) {
            fetchAnnouncementQueryById()
            setIsLoading(false)
          } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
            setIsLoading(false)
          }
        }
        )
    },
    []
  )

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      OwnerTypeId: 111,
      OwnerId: parmas?.id,
      FileTypeId: 0,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setAnnouncementImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Announcement',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[announcementImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  useEffect(() => {

    if (isQuery) {
      setSelectedAnnouncement(announcementsQuery?.result?.items)
      const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: announcementsQuery?.result?.items?.MediaMappings?.MediaFiles });
      setMediaFiles(localSelectedMedia)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {

      mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )
      const announcementData = {

        ...selectedAnnouncement,
        MediaMappings: {
          ...selectedAnnouncement?.MediaMappings,
          MediaFiles: mediaFiles
        },
        MappedChannels: {
          MappedChannelIds: selectedAnnouncement?.MappedChannels?.MappedChannelIds
        },
        LimitedToOrganizationMappings: {
          LimitedToOrganizationUnitIds: selectedAnnouncement?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds
        },
      }
      dispatch(announcements.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements`,
        entity: 'announcements',
        jsonData: {
          Records: [
            announcementData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      const announcementData = {
        ...selectedAnnouncement,
        LimitedToOrganizationMappings: {
          LimitedToOrganizationUnitIds: selectedAnnouncement?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds
        },
      }
      dispatch(announcements.create({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements`,
        entity: 'announcements',
        jsonData: {
          Records: [
            announcementData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/cms/announcements')
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setMediaInfo()
      }
    },
    [mediaFiles]
  )

  const formatWebpagesListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Id,
        WebpageName: `${product?.Name} : ${product?.AccountName}`,
      };
      return item
    });
  };

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <AnnouncementComponent
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedAnnouncement={selectedAnnouncement}
          announcementType={libraryData?.result?.AnnouncementType}
          organizationUnits={organizationUnitsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          handleInnerFormItemChange={handleInnerFormItemChange}
          id={parmas?.id}
          websites={websitesItems?.result?.items}
          webpages={formatWebpagesListData(webPagesItems?.result?.items)}
        />
      }
    </>
  )

}

export default ManagementAnnouncement;